import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import GameDetailsView from '../containers/GameDetailsView';
import './Games.css'; // Import your CSS file
import GameContentProvider from '../providers/GameContentProvider';
import { useTranslation } from 'react-i18next';

// 1. IMPORT YOUR GLOBAL CONFIG
import { IS_TESTING_CAMPAIGN } from '../config'; // Adjust path if needed

import UsaFlag from '../assets/us-flag.png';
import BgFlag from '../assets/bg-flag.png';
import singleImg from '../assets/single.jpg';
import groupImg from '../assets/groups.jpg';

const Games = () => {
  const [games, setGames] = useState([]);
  const [city, setCity] = useState("");
  const location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const fetchGames = async () => {
      const { state } = location;
      console.log('Received data:', state);
      let cityLocal;
      if (state) {
        setCity(state.city);
        cityLocal = state.city;
      }

      try {
        const gameContentProvider = new GameContentProvider();
        const data = await gameContentProvider.getGames(cityLocal, i18n.language);
        setGames(data);
        console.log(data);
      } catch (error) {
        console.error('Error fetching games:', error);
      }
    };

    fetchGames();
  }, [location, i18n.language]); // Added dependencies to useEffect

  return (
    <div className="games-container">
      <h2 className="games-heading">{t('explore_games')}</h2>
      <Routes>
        <Route path={`/gameDetails/:title`} element={<GameDetailsView />} />
        <Route
          path="/"
          element={
            games && games.length > 0 ? (
              <ul className="games-list">
                {/* ----------------------------------------- */}
                {/* ADDED FILTER RIGHT HERE BEFORE THE MAP    */}
                {/* ----------------------------------------- */}
                {games
                  .filter((game) => game.showGame === 1) 
                  .map((game) => (
                  <li key={game.id} className="game-item">
                    <Link to={`/gameDetails/${game.title}`} className="game-link">
                      <div className="game-card">
                        <img
                          src={process.env.PUBLIC_URL + game.imageUrl}
                          alt={game.title}
                          className="game-image"
                        />
                        <div className="game-info">
                          <h3 className="game-title">{game.title}</h3>
                          <h3 className="game-city">{game.city}</h3>
                          <p className="game-description">
                            {game.description?.length > 100
                              ? `${game.description.substring(0, 100)}...`
                              : game.description}
                          </p>

                          {/* ----------------------------------------- */}
                          {/* TESTING CAMPAIGN LOGIC                    */}
                          {/* ----------------------------------------- */}
                          {IS_TESTING_CAMPAIGN ? (
                             <div className="game-prices">
                                <p className="game-price campaign-free" style={{ color: '#ff6347', fontWeight: 'bold' }}>
                                    {t('free')}
                                </p>
                             </div>
                          ) : game.reducedPrice && game.reducedPrice < game.price ? (
                            <div className="game-prices">
                              <p className="game-regular-price">
                                <span className="price">{Number(game.price).toFixed(2)}</span>
                                <span className="currency">{game.currency.toUpperCase()}</span>
                              </p>
                              <p className="game-reduced-price">
                                <span className="price">{Number(game.reducedPrice).toFixed(2)}</span>
                                <span className="currency">{game.currency.toUpperCase()}</span>
                              </p>
                            </div>
                          ) : (
                            <p className="game-price">
                              <span className="price">{Number(game.price).toFixed(2)}</span>
                              <span className="currency">{game.currency.toUpperCase()}</span>
                            </p>
                          )}
                          {/* ----------------------------------------- */}

                          <div className="game-flags">
                            {game.type === 1 && (
                              <img src={singleImg} alt="Single Game Type" className="type-image" />
                            )}
                            {game.type === 2 && (
                              <img src={groupImg} alt="Group Game Type" className="type-image" />
                            )}

                            <div className="game-difficulty" title="Difficulty">
                              {[1, 2, 3].map((i) => (
                                <span
                                  key={i}
                                  className={`difficulty-symbol ${i <= game.level ? 'active' : 'inactive'}`}
                                >
                                  🔥
                                </span>
                              ))}
                            </div>

                            <div className="flag-container">
                              {game.bg === 1 && (
                                <img src={BgFlag} alt="BG Flag" className="flag-image" />
                              )}
                              {game.eng === 1 && (
                                <img src={UsaFlag} alt="USA Flag" className="flag-image" />
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="game-overlay">
                          <span className="play-icon">▶</span>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="no-games">{t('no_games_found') || 'No games available.'}</p>
            )
          }
        />
      </Routes>
    </div>
  );
};

export default Games;